//function to add gap to separate bars in the chart
export const getDataWithGapAttribute = data => {
  return data?.map(data => ({ ...data, gap: data.exchange_percentage && data.refund_percentage ? 1 : 0 }))
}
